import axios from 'axios';
import Logger from '../libs/logger/Logger';
import query_string_utils from '../libs/queryStringUtils';
import { hasActiveUploads } from './intakeLoop/helpers/hasActiveUploads';

const { enabled, timeout } = VersionCheck;
const currentVersion = Version;

export async function startVersionCheckLoop() {
  if (enabled) {
    await checkVersion();
  }
}

async function checkVersion() {
  const updatedVersion = await getVersion();

  if (updatedVersion !== null && currentVersion !== updatedVersion) {
    reloadPageIfPossible(updatedVersion);
  } else {
    setTimeout(checkVersion, timeout);
  }
}

function reloadPageIfPossible(updatedVersion: string) {
  if (!hasActiveUploads()) {
    return;
  }

  let href = query_string_utils.addQueryStringParamToUrl(window.location.toString(), 'v', updatedVersion);

  href = query_string_utils.addQueryStringParamToUrl(href, 'd', Date.now() + '');
  location.href = href;
  location.reload();
}

type VersionData = { version: string };

async function getVersion(): Promise<string | null> {
  try {
    const res = await axios.get<VersionData>(`/ping&t=${Date.now()}`);

    return res.data.version;
  } catch (err) {
    Logger.error(err as Error | string);

    return null;
  }
}
